import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { DashboardLayout, PageCard } from '@vette/ui-components';
import { StripeAccountSettings } from './StripeAccountSettings';
import { useUser } from '@vette/frontend-utils';

type Props = {
  userId: string;
};

export const PayoutsPage: React.FC<Props> = ({ userId }: Props) => {
  const router = useRouter();

  const { user, rules, loading } = useUser();

  useEffect(() => {
    if (user) {
      if (!user?.termsAcceptedAt) router.replace('/terms');
    }
  }, [user]);

  return (
    <DashboardLayout loading={loading} hasStatusToggle>
      <PageCard title="Payouts">
        <StripeAccountSettings
          viewOnly={!rules.canSetupStripe}
          userId={userId}
          stripeAccountConnected={user?.stripeUser?.stripeAccountConnected}
        />
      </PageCard>
    </DashboardLayout>
  );
};
